import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Filter } from '../../interfaces/filter';

@Component({
  selector: 'app-courses-filters',
  templateUrl: './courses-filters.component.html',
  styleUrls: ['./courses-filters.component.scss', './courses-filters.component.en.scss']
})
export class CoursesFiltersComponent {
  @Input({ required: true }) periodFilterItems!: Filter[];
  @Input({ required: true }) typeFilterItems!: Filter[];
  @Input({ required: true }) searchPlaceholder!: string;
  @Input({ required: true }) periodFilterMobileTitle!: string;
  @Input({ required: true }) typeFilterMobileTitle!: string;
  @Input() searchValue: string = '';
  @Input() disabled: boolean = false;
  @Input() isLoading: boolean = false;

  @Output() periodFilterChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() typeFilterChange: EventEmitter<Filter[]> = new EventEmitter<Filter[]>();
  @Output() searchFiledChange: EventEmitter<Event> = new EventEmitter<Event>();

  periodFilterChangeEvent(value: Filter[]) {
    this.periodFilterChange.emit(value);
  }

  typeFilterChangeEvent(value: Filter[]) {
    this.typeFilterChange.emit(value);
  }

  onKeySearch(value: Event) {
    this.searchFiledChange.emit(value);
  }
}
